import { Directive, OnDestroy } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HighchartsChartComponent } from 'highcharts-angular';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'highcharts-chart[appAutoReflow]'
})
export class HighchartsAutoReflowDirective implements OnDestroy {
  private resizeObserver?: ResizeObserver;
  private chart?: Highcharts.Chart;
  private subscription: Subscription;

  constructor(host: HighchartsChartComponent) {
    this.subscription = host.chartInstance.subscribe((chart: Highcharts.Chart) => this.attach(chart));
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    this.subscription.unsubscribe();
  }

  private attach(chart: Highcharts.Chart) {
    this.chart = chart;
    this.resizeObserver?.disconnect();
    if (typeof ResizeObserver === 'undefined') return;
    const target = chart.container?.parentElement;
    if (!target) return;
    this.resizeObserver = new ResizeObserver(() => this.chart?.reflow());
    this.resizeObserver.observe(target);
  }
}
